<template>
    <div class="loading_container">
            <p>Génération en cours</p>
            <p><b-icon icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon></p>
    </div>
</template>

<script>
    export default {
        

    }
</script>

<style lang="scss" scoped>
.loading_container{
    background-color:lightgrey;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>